import { useEffect } from 'react';

export function useScrollToTop(): void {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
}
